import React from 'react'
import { graphql, Link } from 'gatsby'
import clsx from 'clsx'

import Icon from '../Icon/Icon'

import './button.scss'

export const Button = ({
  label = '',
  variant = 'primary',
  otherClasses,
  form,
  external,
  slug,
  onClick,
}) => {
  const buttonClasses = clsx(
    otherClasses,
    variant === 'primary' &&
      `text-base font-Work_Sans leading-6 font-semibold text-gray-900 px-8 py-3 rounded-full bg-accent_orange_600 hover:bg-accent_orange_300 button_primary`,
    variant === 'secondary' &&
      `text-base font-Work_Sans leading-6 font-semibold text-white px-8 py-3 rounded-full bg-transparent border-[1px] border-accent_orange_600 hover:border-accent_orange_300 active:border-white button_secondary`,
    variant === 'text-link' &&
      `bg-transparent text-base font-Work_Sans leading-6 p-[6px] font-semibold text-white hover:text-accent_orange_600 active:text-white button_text_link`
  )

  if (slug) {
    const { current } = slug
    return (
      <Link
        className={buttonClasses}
        to={external ? `${current}` : `/${current}`}
        target={external ? '_blank' : '_self'}
        rel={external ? 'noopener noreferrer' : ''}
      >
        {label}
      </Link>
    )
  }

  return (
    <button
      onClick={(e) => {
        onClick && onClick(form, e)
      }}
      className={buttonClasses}
      data-testid="button"
    >
      {label}
    </button>
  )
}

export default Button

export const query = graphql`
  fragment Button on SanityButton {
    label
    variant
    action
    external
    form
    slug {
      current
    }
  }
`
